import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "work-plateform-page custom-page"
};
import { onMounted, ref } from 'vue';
import NoticeDialog from './components/NoticeDialog.vue';
import RecentWork from './components/recentWork.vue';
import Topcard from './components/topcard.vue';
import Digiproperty from './components/digiproperty.vue';
import ResourceCenter from './components/resourceCenter.vue';
import ApplicationCenter from './components/ApplicationCenter.vue';
import TemplateCenter from './components/TemplateCenter.vue';
import { ElMessageBox, ElMessage } from 'element-plus';
import 'element-plus/es/components/message-box/style/index'
import 'element-plus/es/components/message/style/index'

import { useRouter } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    const recentWork = ref(null);
    const noticeDialog = ref(null);
    const router = useRouter();
    const handleAdClick = () => {
      window.open('https://pro.lzwcdm.com/', '_blank');
    };
    onMounted(() => {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let hasShownBindingPrompt = localStorage.getItem('hasShownBindingPrompt');
      // 没绑定微信公众号
      if (userInfo && !userInfo.openid && !hasShownBindingPrompt) {
        ElMessageBox.confirm('您还没有绑定微信。是否现在前往绑定？', '提示', {
          confirmButtonText: '前往绑定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 用户选择了"前往绑定"
          ElMessage({
            type: 'success',
            message: '请按照指引完成绑定操作。'
          });
          router.push('/user-center?operate=bindWechat');
          // 在这里执行绑定的相关逻辑
        }).finally(() => {
          // 无论用户选择了什么，都标记已经显示过提示
          localStorage.setItem('hasShownBindingPrompt', 'true');
        });
      }
      noticeDialog.value.showDialog();
    });
    const handleClose = () => {
      // recentWork.value.openQuickCreation();
    };
    return (_ctx, _cache) => {
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
        class: "custom-page-content"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "ad-container"
        }, [_createElementVNode("img", {
          src: "https://client-file.lzwcdm.com/static/2.png",
          alt: "广告",
          onClick: handleAdClick
        })]), _createVNode(Topcard), _createVNode(RecentWork, {
          ref_key: "recentWork",
          ref: recentWork
        }, null, 512), _createVNode(ApplicationCenter), _createVNode(TemplateCenter), _createVNode(Digiproperty), _createVNode(NoticeDialog, {
          ref_key: "noticeDialog",
          ref: noticeDialog,
          onHandleClose: handleClose
        }, null, 512)]),
        _: 1
      })]);
    };
  }
};